import {HttpRequest} from '../../../settings/HttpRequest/HttpRequest';
import {DateFormat} from "../../../settings/DateFormat/DateFormat";

export const ProductoService = {
	Listar: (filtro, paginacion) => {
		let params = {
			filtro: {
				clave: filtro.clave || null,
				producto: filtro.producto || null,
				activo: filtro.activo || null
			},
			paginacion: {
				total: paginacion.total || null,
				page: paginacion.page || null,
				limit: paginacion.limit || null
			}
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Producto_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Agregar: (form) => {
		let fecha_oferta = (form.fecha_oferta || null) ? DateFormat.FormatSql(form.fecha_oferta) : null;
		
		let params = {
			id_producto: form.id_producto,
			id_cat_grupo: form.id_cat_grupo,
			id_cat_categoria: form.id_cat_categoria,
			clave: form.clave,
			producto: form.producto,
			descripcion: form.descripcion,
			cantidad: form.cantidad,
			colores: form.colores,
			tallas: form.tallas,
			stocks: form.stocks,
			precio_unitario: form.precio_unitario,
			codigo_descuento: form.codigo_descuento,
			imagen_archivo: form.imagen_archivo,
			imagen_formato: form.imagen_formato,
			imagen1_archivo: form.imagen1_archivo,
			imagen1_formato: form.imagen1_formato,
			imagen2_archivo: form.imagen2_archivo,
			imagen2_formato: form.imagen2_formato,
			imagen3_archivo: form.imagen3_archivo,
			imagen3_formato: form.imagen3_formato,
			imagen4_archivo: form.imagen4_archivo,
			imagen4_formato: form.imagen4_formato,
			mini_descripcion: form.mini_descripcion,
			descuento: form.descuento,
			fecha_oferta: fecha_oferta,
			nuevo: form.nuevo,
			activo: form.activo ? 1 : 0,
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Producto_Guardar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Modificar: (form) => {
		let fecha_oferta = (form.fecha_oferta || null) ? DateFormat.FormatSql(form.fecha_oferta) : null;
		
		let params = {
			id_producto: form.id_producto,
			id_cat_grupo: form.id_cat_grupo,
			id_cat_categoria: form.id_cat_categoria,
			clave: form.clave,
			producto: form.producto,
			descripcion: form.descripcion,
			cantidad: form.cantidad,
			colores: form.colores,
			tallas: form.tallas,
			stocks: form.stocks,
			precio_unitario: form.precio_unitario,
			codigo_descuento: form.codigo_descuento,
			imagen_archivo: form.imagen_archivo,
			imagen_formato: form.imagen_formato,
			imagen1_archivo: form.imagen1_archivo,
			imagen1_formato: form.imagen1_formato,
			imagen2_archivo: form.imagen2_archivo,
			imagen2_formato: form.imagen2_formato,
			imagen3_archivo: form.imagen3_archivo,
			imagen3_formato: form.imagen3_formato,
			imagen4_archivo: form.imagen4_archivo,
			imagen4_formato: form.imagen4_formato,
			mini_descripcion: form.mini_descripcion,
			descuento: form.descuento,
			fecha_oferta: fecha_oferta,
			nuevo: form.nuevo,
			activo: form.activo ? 1 : 0,
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Producto_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	ModificarCatalogo: (form) => {
		let params = {
			imagen_archivo: form.imagen_archivo,
			imagen_formato: form.imagen_formato,
			activo: form.activo ? 1 : 0,
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Producto_Modificar_Catalogo', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Eliminar: (id_producto) => {
		let params = {
			id_producto: id_producto
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Producto_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Codigo: (id_cat_categoria) => {
		let params = {
			id_cat_categoria:id_cat_categoria
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Producto_Codigo', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	}
};
